import { Col, Form, Row } from "react-bootstrap";
import { ClientGeneralParams } from "../../types";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";
import { selectClientParamsLogoFileName } from "../../../../../redux/clientParamsSlice";
import '../GeneralParams.css'
import AppAttachFileInput from "../../../../../components/AppInput/AppAttachFileInput";
import { LanguageEnum } from "../../types/enum";

interface GeneralParamsSectionFormProp {
    updateField: (field: keyof ClientGeneralParams, value: any) => void;
    onRemoveLogo: () => void;
    logoResetTrigger: number;
}

export default function GeneralParamsSectionForm({ updateField, onRemoveLogo, logoResetTrigger }: GeneralParamsSectionFormProp) {
    const { t } = useTranslation(['clientParams']);
    const errors = useSelector((state: RootState) => state.clientParamsForm.errors);
    const initialLogoName = useSelector(selectClientParamsLogoFileName);
    const clientParams = useSelector((state: RootState) => state.clientParamsForm.data);

    return (
        <Form>
            <Form.Group as={Row} className="mb-3 d-flex align-items-center">
                <Form.Label column md={6}>{t("clientParams:form.logoLabel")}</Form.Label>
                <Col md={6}>
                    <Form.Label className="form-sublabel">{t("clientParams:form.logoSubLabel")}</Form.Label>
                    <AppAttachFileInput
                        showLabel={false}
                        onSelectFile={(file) => {
                            updateField("logoFile", file);
                        }}
                        onClear={onRemoveLogo}
                        clearTrigger={logoResetTrigger}
                        initialFileName={initialLogoName}
                        fileType={"image"}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors?.campaignSurveysSendingTime}
                    </Form.Control.Feedback>                        
                </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3 mt-4 d-flex align-items-center" controlId="emailUAC">
                <Form.Label column md={6}>{t("clientParams:form.emailUACLabel")}</Form.Label>
                <Col md={6}>
                    <Form.Control
                        value={clientParams.emailUAC ?? ""}
                        onChange={(e) => updateField("emailUAC", e.target.value)}
                        isInvalid={!!errors?.emailUAC}
                        type="email"
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors?.emailUAC}
                    </Form.Control.Feedback>
                </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3 mt-4" controlId="emailUACSubject">
                <Form.Label column md={6}>{t("clientParams:form.emailUACSubjectLabel")}</Form.Label>
                <Col md={6}>
                    <Form.Control
                        value={clientParams.emailUACSubject ?? ""}
                        onChange={(e) => updateField("emailUACSubject", e.target.value)}
                        isInvalid={!!errors?.emailUACSubject}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors?.emailUACSubject}
                    </Form.Control.Feedback>
                </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3 mt-4" controlId="emailUACBody">
                <Form.Label column md={6}>{t("clientParams:form.emailUACBodyLabel")}</Form.Label>
                <Col md={6}>
                    <Form.Control
                        as="textarea"
                        rows={5}
                        value={clientParams.emailUACBody ?? ""}
                        onChange={(e) => updateField("emailUACBody", e.target.value)}
                        isInvalid={!!errors?.emailUACBody}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors?.emailUACBody}
                    </Form.Control.Feedback>
                </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3 mt-4 d-flex align-items-center" controlId="language">
                <Form.Label column md={6}>{t("clientParams:form.language.label")}</Form.Label>
                <Col md={6}>
                    <Form.Select
                        value={clientParams.language}
                        onChange={(e) => updateField("language", e.target.value)}
                        isInvalid={!!errors?.language}
                    >
                        {Object.entries(LanguageEnum)
                            .filter(([key]) => isNaN(Number(key)))
                            .map(([key, value]) => (
                                <option key={key} value={value}>
                                    {t(`clientParams:form.language.${key}`)}
                                </option>
                            )
                        )}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                        {errors?.language}
                    </Form.Control.Feedback>
                </Col>

            </Form.Group>
            <Form.Group as={Row} className="mb-3 mt-4 d-flex align-items-center" controlId="writeAiSuggestedReplyInCurrentLanguage">
                <Form.Label column md={6}>{t("clientParams:response.language")}</Form.Label>
                <Col md={6}>
                    <Form.Check
                        className="my-4"
                        type="switch"
                        id="response-language-switch"
                        
                        checked={clientParams.writeAiSuggestedReplyInCurrentLanguage ?? false}
                        onChange={(e) => updateField("writeAiSuggestedReplyInCurrentLanguage", e.target.checked)}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors?.writeAiSuggestedReplyInCurrentLanguage}
                    </Form.Control.Feedback>
                </Col>
            </Form.Group>
        </Form>
    );
}
